import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHumblebundleComponent } from './simple-icons-humblebundle.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHumblebundleComponent ],
    exports:      [ SimpleIconsHumblebundleComponent ],
    bootstrap:    []
})
export class SimpleIconsHumblebundleModule {}
